import { RRIBaseModel } from '../../interfaces/base-model.interface';
import { RRISort } from '../../interfaces/base-sort.interface';
import { RRTableAction } from '../../types/table-action.type';
import { RRTableFieldSettingsModel } from './table-fields.model';

export interface RRTableModel<T extends RRIBaseModel> {
  fieldsToShow: RRTableFieldSettingsModel<T>[];
  results: T[];
  visibleColumns?: (keyof T)[];
  sortBy?: RRISort<T>;
  hideTable?: boolean;
  tableClass?: string;
  showSelectColumn?: boolean;
  showRadioColumn?: boolean;
  showScrollBar?: boolean;
  invisibleRows?: number[];
  tableActions?: RRTableAction<T>[];
  showSelectAll?: boolean;
}
